export default "__VITE_ASSET__5Fl_a6R4__"